import meetingGetters from "./getters.js";
import meetingMutations from "./mutations.js";
import meetingActions from "./actions.js";

export default {
  namespaced: true,
  state() {
    return {
      meetingsLoaded: false,
      meetings: [],
    };
  },
  getters: meetingGetters,
  mutations: meetingMutations,
  actions: meetingActions,
};
